import { render } from "./icon-alert-danger.svg?vue&type=template&id=6e0cf5e0"
const script = {}

import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__